import { __assign } from "tslib";
import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { isValid } from 'date-fns';
import { Person } from 'models';
import { CUSTOMER_LIST_QUERY } from 'models/queries';
var useCustomerList = function (customer) {
    var _a = useLazyQuery(CUSTOMER_LIST_QUERY), getListData = _a[0], _b = _a[1], data = _b.data, loading = _b.loading;
    useEffect(function () {
        if (customer) {
            var firstName = customer.firstName, lastName = customer.lastName, dateOfBirth = customer.dateOfBirth, _a = customer.address, zipcode = _a.zipcode, state = _a.state, preferredPhone = customer.phones[0];
            var preferredPhoneNumber = (preferredPhone || {}).phoneNumber;
            var getPhoneDigits = function (phone) {
                return phone.replaceAll(/[()\s-]/g, '');
            };
            getListData({
                variables: {
                    wherePerson: __assign(__assign(__assign(__assign(__assign({}, (firstName ? { firstName: { contains: firstName } } : {})), (lastName ? { lastName: { contains: lastName } } : {})), (zipcode || state
                        ? {
                            address: __assign(__assign({}, (zipcode ? { zipcode: { contains: zipcode } } : {})), (state ? { state: { contains: state } } : {}))
                        }
                        : {})), (preferredPhoneNumber
                        ? {
                            phones: {
                                some: {
                                    phoneNumber: {
                                        contains: getPhoneDigits(preferredPhoneNumber)
                                    },
                                    preferred: {
                                        eq: true
                                    }
                                }
                            }
                        }
                        : {})), (isValid(dateOfBirth)
                        ? {
                            dateOfBirth: {
                                lte: dateOfBirth.toISOString()
                            }
                        }
                        : {}))
                }
            });
        }
    }, [customer, getListData]);
    return {
        customers: (data === null || data === void 0 ? void 0 : data.persons.nodes.map(function (node) { return new Person(node); })) || [],
        loading: loading
    };
};
export default useCustomerList;
//# sourceMappingURL=useCustomerList.js.map